<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative;display:flex;justify-content: space-between;height: 28px;line-height: 28px;">
        <Breadcrumb>
          <BreadcrumbItem to="/home">
            <Icon type="icon iconfont icon-xitong" /> 系统首页
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理
          </BreadcrumbItem>
          <BreadcrumbItem to="/system/Street">
            <Icon type="icon iconfont icon-quyu" /> 街道管理
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Icon type="md-add-circle" />  新增街道
          </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top:12px; ">
        <div class="titlable">
          <span>新增街道基本信息</span>
        </div>

        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
          <FormItem prop="user_name">
            <Input v-model="formValidate.user_name" class="inptext" size="large" placeholder="请输入登录用户名" />
          </FormItem>
          <FormItem prop="street_name">
            <Input v-model="formValidate.street_name" class="inptext" size="large" placeholder="请输入街道名称" />
          </FormItem>
          <FormItem prop="areaid">
            <Cascader v-model="formValidate.areaid" :data="areadata" placeholder="请选择省市区" class="inptext" change-on-select />
          </FormItem>
          <FormItem>
            <Button @click="backmast">返回</Button>
            <Button type="primary" style="margin-left: 32px" @click="handleSubmit('formValidate')">提交</Button>
          </FormItem>
        </Form>

      </Card>
    </X-Layout>
  </div>
</template>

<script>
export default {
    data() {
        return {
            // 表单验证数据
            formValidate: {
                user_name: '', // 用户名
                street_name: '', // 街道名称
                areaid: ['811', '824', '829'] //  默认是选中 新吴区
            },
            ruleValidate: { // 定义数据验证
                user_name: [
                    { required: true, message: '登录用户名不能为空!', trigger: 'blur' }
                ],
                street_name: [
                    { required: true, message: '街道名称不能为空!', trigger: 'blur' }
                ],
                areaid: [
                    { type: 'array', required: true, message: '省市区不能为空!', trigger: 'change' }
                ]

            },
            areadata: []// 省市县

        };
    },

    mounted() {
       
        this.getsheng();// 初始化省市区
    },
    methods: {
        /**
         * 验证表单提交事件
         */
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    // 运行提交方法
                    this.addcompany();
                } else {
                    this.$Message.error('失败!');
                }
            });
        },
        /**
         * 初始化省市县
         */
        getsheng() {
            const api = this.ApiUrl + 'area/findAllArea';
            const data = {
                'area_id': 1
            };
            this.$http.post(api, data).then(res => {
                
                if (res.data.extend.news === 0) {
                    const list = res.data.extend.area;
                    // 处理一下下拉支持的格式
                    for (var i = 0; i < list.length; i++) {
                        if (!list[i].children) {
                            list[i].children = list[i].list2;
                        }
                    }
                    this.areadata = list;
                   
                }
            }, res => {

            });
        },
        // 刷新页面
        reload() {
            location.reload();
        },

        /**
         * 添加街道
         */
        addcompany() {
            const data = {
                street_account: this.formValidate.user_name,
                street_name: this.formValidate.street_name,
                area_id: this.formValidate.areaid[2]// 选中的县
            };
            const api = this.ApiUrl + 'street/addStreet';
            this.$http.post(api, data).then(res => {
                if (res.data.extend.news === 0) {
                    this.$Message.success('添加成功');

                    // 返回页
                    setTimeout(() => {
                        this.backmast();
                    }, 1800);
                } else {
                    this.$Message.warning(res.data.extend.message);
                }
            }, res => {

            });
        },

        // 返回主页
        backmast() {
            this.$router.push({
                path: '/system/Street'
            });
        }

    }
};
</script>

<style scoped>
	.icon{
		font-size: 1.5rem;
	}
	.inptext {
		margin-top: 0.625rem;
		width: 25rem;
	}
	.refresh{
		float:right;
		margin-right: 1.25rem;
	}

	.picbox{
		height: 12.5rem;
		width: 12.5rem;
		border: 1px solid #ccc;
	}
	.titlable{
		height: 24px;
		border-left: 0.125rem solid  #17233d;
		padding-left: 20px;
		line-height: 24px;
		margin-bottom: 20px;
	}

	.cominfo{
		display: flex;
		flex-direction: column;

	}
	.ivu-input{
		width: 25rem;
	}
	.inptext{
		margin-top: 0.625rem;
		width: 25rem;
	}

	.inpuarea{
		margin-top: 0.625rem;
		width: 25rem;

	}

	.btnbox{
		margin-top: 1.25rem;
		width: 25rem;
		display: flex;

	}
	.btnbox > button{
		margin-right: 200px;
	}
</style>

